<template>
   <section class="pt-24">
         <div class="text-left"> 
              <h1 class="text-indigo-600 text-3xl font-medium">Vote your <span class="block"> favourite candidate</span> </h1>
              <p class="text-gray-600 text-sm mt-4"> Choose your favourite Candidate and vote for them below</p>
        </div>
        <!-- DEVELOPER CARD WITH AVALIBALE DEVS -->
    <candidate-card :candidates="candidates" @contact="contact"></candidate-card>

     <candidate-form :voteStatus="voteStatus" :candidate="candidate" v-if="showform===true" @remove="removeForm"></candidate-form>
     </section>
</template>

<script>
import CandidateCard from "../Utilities/CandidateCard";
import CandidateForm from '../Forms/CandidateForm';
export default {
  components: {
    CandidateCard,
    CandidateForm
  },
   methods:{
 contact(id,vote){
   this.voteStatus=vote
     this.candidates.forEach((can)=>{
         if(id === can.id){
             this.candidate = can
             this.showform=true
         }
     })
 },
 removeForm(){
   this.showform=false
 },
  async fetch() {
    try {
      const response = await fetch(
        // "https://nodes-testnet.wavesnodes.com/addresses/data/3MsCcWZK2H5fR6xc6hJy6Mw1iaH47NWjZpg?matches=.*?_candidateProfile"
        `${this.nodeUrl}/addresses/data/${this.dAppAddress}?matches=.*?_candidateProfile`

      )
      const responded = await response.json()
      
      console.log(responded)
      console.log(`${this.nodeUrl}/addresses/data/${this.dAppAddress}?matches=.*?_candidateProfile`)
      responded.forEach((res,id)=>{
        const candidate = {
          id : responded[id].key,
          name: responded[id].value.split('_')[0],
          bio: responded[id].value.split('_')[2],
          image: responded[id].value.split('_')[1],
          sex: responded[id].value.split('_')[3],
          role: responded[id].value.split('_')[4],
        }
        this.candidates.push(candidate)
      })
      console.log(this.candidates)
    } catch (error) {}
  },
  },

   data() {
    return {
        candidate:'',
        candidates:[],
        showform: false,
        voteStatus: null,
       isTestnet: true,
    };
  },
  computed: {
    nodeUrl() {
      return this.isTestnet
        ? 'https://nodes-testnet.wavesnodes.com'
        : 'https://nodes.wavesplatform.com'
    },
    dAppAddress() {
      return this.isTestnet
        ? '3MsCcWZK2H5fR6xc6hJy6Mw1iaH47NWjZpg'
        : '3PPiE3H2Xrd1e5cqEs39ezVDMtRWcgJ1HgN'
    },
  },

  mounted(){
    this.fetch()
  
}

}
</script>

<style>

</style>